import { Controller } from '@hotwired/stimulus'
import FingerprintJS from '@fingerprintjs/fingerprintjs-pro'

export default class extends Controller {
  static values = { endpoint: String, publicKey: String }

  connect() {
    const fpPromise = FingerprintJS.load({
      apiKey: this.publicKeyValue,
      endpoint: [
        this.endpointValue,
        FingerprintJS.defaultEndpoint
      ],
      scriptUrlPattern: [
        `${this.endpointValue}/web/v<version>/<apiKey>/loader_v<loaderVersion>.js`,
        FingerprintJS.defaultScriptUrlPattern
      ],
      region: 'eu'
    })

    fpPromise
      .then(fp => fp.get())
      .then(result => {
        const seed = Math.random().toString(16).substring(2, 7)
        const img = document.createElement('img')
        img.src = `/images/bfp-${result.visitorId}-${seed}.png`
        this.element.appendChild(img)
      })
  }
}
